import { render, staticRenderFns } from "./Get724.vue?vue&type=template&id=be8221c8&scoped=true&"
import script from "./Get724.vue?vue&type=script&lang=js&"
export * from "./Get724.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be8221c8",
  null
  
)

export default component.exports